var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.40039 2.3999V12.3555C2.40039 12.6855 2.5315 13.002 2.76488 13.2354C2.99826 13.4688 3.31479 13.5999 3.64484 13.5999H13.6004M10.4893 3.64435H11.7337C12.0774 3.64435 12.3559 3.92293 12.3559 4.26657V10.4888C12.3559 10.8324 12.0774 11.111 11.7337 11.111H10.4893C10.1456 11.111 9.86706 10.8324 9.86706 10.4888V4.26657C9.86706 3.92293 10.1456 3.64435 10.4893 3.64435ZM5.5115 5.51101H6.75595C7.09959 5.51101 7.37817 5.78959 7.37817 6.13324V10.4888C7.37817 10.8324 7.09959 11.111 6.75595 11.111H5.5115C5.16786 11.111 4.88928 10.8324 4.88928 10.4888V6.13324C4.88928 5.78959 5.16786 5.51101 5.5115 5.51101Z",
    stroke: "#33363F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphIcon);
export default __webpack_public_path__ + "static/media/graphIcon.f6239706647f8cfab640934a6cea8f05.svg";
export { ForwardRef as ReactComponent };